import React from 'react';
import { Link } from 'react-router-dom';
import blueCar from '../assets/images/blue_car.png';
import redCar from '../assets/images/red_car.png';
import smile from '../assets/images/smile.png';
import conduiteSupervisee from '../assets/images/conduite-superviser.png';
import './Services.css';

const Services = () => {
  const services = [
    {
      title: 'Permis B',
      description: 'Cours de conduite',
      subtitle: 'dès 17 ans',
      image: blueCar,
      color: 'orange',
      buttonText: '+Infos',
      link: '/formations-permis-b'
    },
    {
      title: 'Permis AAC',
      description: 'Conduite accompagnée',
      subtitle: 'dès 15 ans',
      image: smile,
      color: 'blue',
      buttonText: '+Infos',
      link: '/aac'
    },
    {
      title: 'Code de la Route',
      description: 'Préparation au code',
      image: redCar,
      color: 'orange',
      buttonText: '+Infos',
      link: '/code'
    },
    {
      title: 'Conduite Supervisée',
      description: 'Pratique supervisée',
      subtitle: 'dès 18 ans',
      image: conduiteSupervisee,
      color: 'blue',
      buttonText: '+Infos',
      link: '/conduite-supervisee'
    }
  ];

  return (
    <section className="services">
      <div className="container">
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className={`service-card ${service.color}`}>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                {service.subtitle && (
                  <p className="service-subtitle">{service.subtitle}</p>
                )}
                <Link to={service.link} className="service-button">
                  {service.buttonText}
                </Link>
              </div>
              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
